module.exports = __webpack_public_path__ + "static/assets/8093f11e854fdbb07b3a3eafdceeaa53.svg";